import { render, staticRenderFns } from "./CarinfoComponent.vue?vue&type=template&id=445d34be"
import script from "./CarinfoComponent.vue?vue&type=script&lang=js"
export * from "./CarinfoComponent.vue?vue&type=script&lang=js"
import style0 from "./CarinfoComponent.vue?vue&type=style&index=0&id=445d34be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports